var _rect, _rect2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 70,
    viewBox: "0 0 304 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 70,
    rx: 15,
    fill: "#1F4E5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 145,
    height: 55,
    rx: 13.5,
    stroke: "#FF0088",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_132_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8371 19.6H29.0371C32.2038 19.6 34.9538 20.25 37.2871 21.55C39.6204 22.8333 41.4288 24.65 42.7121 27C43.9954 29.35 44.6371 32.1167 44.6371 35.3C44.6371 38.45 43.9954 41.2 42.7121 43.55C41.4288 45.9 39.6204 47.7333 37.2871 49.05C34.9538 50.35 32.2038 51 29.0371 51H19.8371V19.6ZM23.7371 23.05V47.6H29.0371C31.4038 47.6 33.4371 47.0667 35.1371 46C36.8538 44.9333 38.1704 43.475 39.0871 41.625C40.0204 39.7583 40.4871 37.65 40.4871 35.3C40.4871 32.9333 40.0204 30.8333 39.0871 29C38.1704 27.15 36.8538 25.7 35.1371 24.65C33.4371 23.5833 31.4038 23.05 29.0371 23.05H23.7371ZM52.8449 51V19.6H56.7449V51H52.8449ZM75.6086 46.85L84.9086 19.6H89.0586L77.8586 51H73.8086L62.7086 19.6H66.8586L76.1086 46.85H75.6086ZM89.6223 51L100.422 19.6H105.172L115.722 51H111.622L108.972 42.95H96.4723L93.7223 51H89.6223ZM97.4723 39.9H107.972L102.722 24.35L97.4723 39.9ZM122.033 19.6H126.683L142.633 45.45H142.283V19.6H146.183V51H141.833L125.333 24.3H125.933V51H122.033V19.6Z",
    fill: "#FF0088"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_132_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.8 51V19.6H177.75C181.333 19.6 184.042 20.4583 185.875 22.175C187.725 23.875 188.65 26.1167 188.65 28.9C188.65 31.65 187.725 33.8833 185.875 35.6C184.042 37.3 181.333 38.15 177.75 38.15H170.7V51H166.8ZM184.4 51L175.4 36.75H179.65L189.45 51H184.4ZM170.7 35.4H177.45C179.8 35.4 181.583 34.825 182.8 33.675C184.033 32.5083 184.65 31 184.65 29.15C184.65 27.25 184.058 25.7417 182.875 24.625C181.708 23.5083 180 22.95 177.75 22.95H170.7V35.4ZM208.515 51.6C205.915 51.6 203.59 51 201.54 49.8C199.49 48.6 197.874 46.8 196.69 44.4C195.507 41.9833 194.915 38.9667 194.915 35.35C194.915 31.6833 195.507 28.65 196.69 26.25C197.874 23.8333 199.49 22.0333 201.54 20.85C203.59 19.65 205.915 19.05 208.515 19.05C211.115 19.05 213.44 19.65 215.49 20.85C217.54 22.05 219.157 23.8583 220.34 26.275C221.524 28.6917 222.115 31.7167 222.115 35.35C222.115 39 221.524 42.0333 220.34 44.45C219.157 46.85 217.54 48.6417 215.49 49.825C213.44 51.0083 211.115 51.6 208.515 51.6ZM208.515 48C211.465 48 213.79 46.925 215.49 44.775C217.207 42.625 218.065 39.4667 218.065 35.3C218.065 31.2167 217.207 28.075 215.49 25.875C213.79 23.6583 211.465 22.55 208.515 22.55C205.599 22.55 203.274 23.6583 201.54 25.875C199.824 28.0917 198.965 31.25 198.965 35.35C198.965 39.5 199.824 42.65 201.54 44.8C203.274 46.9333 205.599 48 208.515 48ZM240.791 51.6C238.191 51.6 235.866 51 233.816 49.8C231.766 48.6 230.149 46.8 228.966 44.4C227.782 41.9833 227.191 38.9667 227.191 35.35C227.191 31.6833 227.782 28.65 228.966 26.25C230.149 23.8333 231.766 22.0333 233.816 20.85C235.866 19.65 238.191 19.05 240.791 19.05C243.391 19.05 245.716 19.65 247.766 20.85C249.816 22.05 251.432 23.8583 252.616 26.275C253.799 28.6917 254.391 31.7167 254.391 35.35C254.391 39 253.799 42.0333 252.616 44.45C251.432 46.85 249.816 48.6417 247.766 49.825C245.716 51.0083 243.391 51.6 240.791 51.6ZM240.791 48C243.741 48 246.066 46.925 247.766 44.775C249.482 42.625 250.341 39.4667 250.341 35.3C250.341 31.2167 249.482 28.075 247.766 25.875C246.066 23.6583 243.741 22.55 240.791 22.55C237.874 22.55 235.549 23.6583 233.816 25.875C232.099 28.0917 231.241 31.25 231.241 35.35C231.241 39.5 232.099 42.65 233.816 44.8C235.549 46.9333 237.874 48 240.791 48ZM261.966 19.6H267.566L278.366 41.3H277.966L288.766 19.6H294.216V51H290.266V23.65H290.966L279.466 47.05H276.866L265.416 23.8H265.866V51H261.966V19.6Z",
    fill: "#D8D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_132_2",
    x: 15.8372,
    y: 19.6001,
    width: 134.346,
    height: 39.3999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_132_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_132_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_132_2",
    x: 162.8,
    y: 19.05,
    width: 135.416,
    height: 40.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_132_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_132_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2dcc8d038223a2354331283e58a226ba.svg";
export { ForwardRef as ReactComponent };